import { ButtonSwitch } from "../ButtonSwitch/ButtonSwitch";

interface GenderSelectorProps {
  value: string | null;
  onChange: (gender: string) => void;
}

const genderToActive = (gender: string | null): "left" | "middle" | "right" | undefined => {
  if (gender === "Male") return "left";
  if (gender === "Female") return "middle";
  if (gender === "Other") return "right";
  return undefined;
};

export const GenderSelector: React.FC<GenderSelectorProps> = ({ value, onChange }) => {
  return (
    <ButtonSwitch
      leftButtonChildren="Male"
      middleButtonChildren="Female"
      rightButtonChildren="Other"
      active={genderToActive(value)}
      onLeftButtonClick={() => onChange("Male")}
      onMiddleButtonClick={() => onChange("Female")}
      onRightButtonClick={() => onChange("Other")}
    />
  );
};

GenderSelector.displayName = "GenderSelector";
